/* Great Lakes Lavender Farm — policy pages */
(function () {
  "use strict";
  var roots = document.querySelectorAll(".gpl[data-gpl]");
  Array.prototype.forEach.call(roots, function (root) {
    if (root.__gpl) return; root.__gpl = true; root.classList.remove("gpl-nojs");
    var RM = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
    var $ = function (s, c) { return (c || root).querySelector(s); };
    var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
    function esc(s) { var d = document.createElement("div"); d.textContent = s; return d.innerHTML; }

    /* sticky header offset */
    function headerBottom() {
      var b = 0;
      document.querySelectorAll(".shopify-section-group-header-group, #shopify-section-header, sticky-header").forEach(function (h) {
        var p = getComputedStyle(h).position; if (p !== "sticky" && p !== "fixed") return;
        var r = h.getBoundingClientRect(); if (r.top <= 2 && r.bottom > b && r.height < innerHeight / 2) b = r.bottom;
      });
      return Math.round(b);
    }
    var topPx = -1;
    function syncTop() { var t = headerBottom(); if (t !== topPx) { topPx = t; root.style.setProperty("--top", t + "px"); } }
    syncTop(); setInterval(function () { if (!document.hidden) syncTop(); }, 250);
    function go(id) {
      var t = document.getElementById(id); if (!t) return;
      var m = $(".gpl-tocm"), extra = m && getComputedStyle(m).display !== "none" ? m.offsetHeight : 0;
      window.scrollTo({ top: t.getBoundingClientRect().top + pageYOffset - Math.max(0, topPx) - extra - 16, behavior: RM ? "auto" : "smooth" });
      try { history.replaceState(null, "", "#" + id); } catch (e) {}
    }
    function toast(msg) {
      var n = document.createElement("div"); n.className = "gpl-toast"; n.setAttribute("role", "status"); n.textContent = msg; root.appendChild(n);
      requestAnimationFrame(function () { n.classList.add("is-on"); });
      setTimeout(function () { n.classList.remove("is-on"); setTimeout(function () { n.remove(); }, 500); }, 2200);
    }
    function copy(text) {
      (navigator.clipboard && navigator.clipboard.writeText ? navigator.clipboard.writeText(text) : Promise.reject()).then(function () { toast("Link copied"); }, function () { window.prompt("Copy this link:", text); });
    }

    /* TOC + progress */
    var links = $$(".gpl-toc a"), secs = $$(".gpl-sec"), bars = $$("[data-gpl-prog]"), left = $("[data-gpl-left]"), jump = $("[data-gpl-jump]"), doc = $(".gpl-doc");
    links.forEach(function (a) { a.addEventListener("click", function (e) { e.preventDefault(); go(a.getAttribute("href").slice(1)); }); });
    if (jump) jump.addEventListener("change", function () { if (jump.value) go(jump.value); });
    var mins = left ? parseInt(left.textContent, 10) || 0 : 0, tick = false;
    function spy() {
      if (!doc) return;
      var r = doc.getBoundingClientRect(), h = r.height - innerHeight * .6, p = Math.min(1, Math.max(0, (-r.top + topPx + 80) / Math.max(1, h)));
      bars.forEach(function (b) { b.style.width = (p * 100).toFixed(1) + "%"; });
      if (left && mins) left.textContent = p >= .98 ? "You&rsquo;re all caught up".replace("&rsquo;", "’") : Math.max(1, Math.ceil(mins * (1 - p))) + " min left";
      var y = Math.max(0, topPx) + 140, on = null;
      secs.forEach(function (s) { if (s.getBoundingClientRect().top <= y) on = s.id; });
      links.forEach(function (a) { a.classList.toggle("is-on", a.getAttribute("href") === "#" + on); });
      if (jump && on && jump.value !== on) jump.value = on;
    }
    window.addEventListener("scroll", function () { if (tick) return; tick = true; requestAnimationFrame(function () { tick = false; spy(); }); }, { passive: true });
    spy();

    /* actions */
    root.addEventListener("click", function (e) {
      var t = e.target.closest && e.target.closest("[data-gpl-print],[data-gpl-share],[data-gpl-anchor],[data-gpl-chat]"); if (!t) return;
      if (t.hasAttribute("data-gpl-print")) window.print();
      else if (t.hasAttribute("data-gpl-share")) copy(location.origin + location.pathname);
      else if (t.hasAttribute("data-gpl-anchor")) copy(location.origin + location.pathname + "#" + t.getAttribute("data-gpl-anchor"));
      else {
        try { if (window.GLLFGrower && GLLFGrower.open) { GLLFGrower.open(); return; } } catch (err) {}
        var l = document.querySelector(".lg-launcher"); if (l) l.click(); else location.href = "/pages/lavender-grower-chat";
      }
    });

    /* claims wizard */
    var wiz = $("[data-gpl-wiz]"), out = $("[data-gpl-result]");
    if (wiz && out) {
      var W = {}; try { W = JSON.parse(wiz.textContent); } catch (e) {}
      var CLAIMS = "/apps/claims";
      function windowText(hours, dateStr) {
        if (!dateStr) return null;
        var d = new Date(dateStr + "T12:00:00"), now = new Date(); now.setHours(12, 0, 0, 0);
        var days = Math.round((now - d) / 864e5);
        if (days < 0) return ["ok", "That date hasn&rsquo;t happened yet — check the delivery date."];
        if (hours === 24) return days === 0 ? ["ok", "Delivered today — you&rsquo;re within the 24-hour window. Report it now."] : days === 1 ? ["ok", "Delivered yesterday — check the delivery time on your tracking. The window is 24 hours from delivery, so report it right away."] : ["no", "The 24-hour Healthy Arrival window has passed. Shipping Protection or the Grow Guarantee may still apply if you purchased them — start a claim and we&rsquo;ll check."];
        var lim = Math.round(hours / 24), leftD = lim - days;
        return leftD >= 0 ? ["ok", "You&rsquo;re within the window — about " + leftD + " day" + (leftD === 1 ? "" : "s") + " left."] : ["no", "This is past the " + lim + "-day window. Contact us and we&rsquo;ll see what we can do."];
      }
      function show(k) {
        var r = W[k]; if (!r) return;
        $$(".gpl-opt").forEach(function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-gpl-opt") === k ? "true" : "false"); });
        out.innerHTML = '<div class="gpl-result"><div><p class="k">' + r.tag + "</p><h3>" + r.prog + "</h3><p>" + r.text + "</p>" +
          (r.hours ? '<div class="gpl-clock"><label for="gpl-deliv">Delivered on</label><input type="date" id="gpl-deliv"><output data-gpl-out aria-live="polite">Enter the delivery date to check your window.</output></div>' : "") +
          '<div class="gpl-btns"><a class="gpl-btn gpl-btn--gold" href="' + CLAIMS + '">Start this claim →</a><a class="gpl-btn gpl-btn--line" href="/pages/protection-terms">Read the terms</a></div></div>' +
          '<div class="gpl-prep"><b>Have these ready</b><ul>' + r.prep.map(function (p) { return "<li>" + p + "</li>"; }).join("") + "</ul></div></div>";
        var inp = $("#gpl-deliv", out), o = $("[data-gpl-out]", out);
        if (inp) {
          var t = new Date(); t.setMinutes(t.getMinutes() - t.getTimezoneOffset()); inp.max = t.toISOString().slice(0, 10);
          inp.addEventListener("change", function () { var w = windowText(r.hours, inp.value); if (w) { o.className = w[0]; o.innerHTML = w[1]; } });
        }
      }
      $$(".gpl-opt").forEach(function (b) { b.addEventListener("click", function () { show(b.getAttribute("data-gpl-opt")); }); });
    }

    /* reveal */
    if ("IntersectionObserver" in window && !RM) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); } }); }, { rootMargin: "0px 0px -6% 0px" });
      $$(".gpl-rv").forEach(function (n) { io.observe(n); });
    } else $$(".gpl-rv").forEach(function (n) { n.classList.add("is-in"); });

    if (location.hash && document.getElementById(location.hash.slice(1)) && root.contains(document.getElementById(location.hash.slice(1)))) setTimeout(function () { go(location.hash.slice(1)); }, 300);
  });
})();
